"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_FUNCTIONS = void 0;
exports.LOCATION_FUNCTIONS = [
    'port',
    'rail_terminal',
    'road_terminal',
    'airport',
    'postal_exchange',
    'multimodal',
    'fixed_transport',
    'border_crossing',
];
//# sourceMappingURL=locations.js.map